// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var offsetRouter = {
  path: '/offStore',
  component: Layout,
  redirect: '/offStore/store',
  name: 'offStore',
  alwaysShow: true,
  meta: {
    title: '核销',
    icon: 'clipboard'
  },
  children: [{
    path: 'store',
    name: "store",
    meta: {
      title: '店铺列表'
    },
    component: function component() {
      return import('@/views/offStore/store/index');
    }
  }, {
    path: 'users',
    name: "users",
    meta: {
      title: '员工列表'
    },
    component: function component() {
      return import('@/views/offStore/users/index');
    }
  }, {
    path: 'manager',
    name: "manager",
    meta: {
      title: '角色管理'
    },
    component: function component() {
      return import('@/views/offStore/manager/index');
    }
  }]
};
export default offsetRouter;